import { useQuery } from '@tanstack/react-query'
import { contactInfoApi } from '@/api/ContactInfo/ContactInfo.api'
import type { ContactInfo } from '@/types'

const CONTACT_INFO_QUERY_KEY = ['contact-info']

export const useContactInfo = () => {
  const query = useQuery<ContactInfo>({
    queryKey: CONTACT_INFO_QUERY_KEY,
    queryFn: async () => {
      const res = await contactInfoApi.get()
      return res.data
    },

    // 🔒 Data gần như tĩnh
    staleTime: Infinity,
    gcTime: Infinity, // ✅ thay cho cacheTime

    // 🚫 Không tự refetch
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  })

  return {
    state: {
      contactInfo: query.data ?? null,
      isLoading: query.isLoading,
      isFetching: query.isFetching,
      isError: query.isError,
      error: query.error,
    },
  }
}
